<template>
    <div>
        <b-navbar></b-navbar>

        <b-navbar
            toggleable="lg"
            type="dark"
            class="navbar-section shift navbar-fixed-top app-navbar"
            v-if="hideMenu"
        >
            <div class="container nav-container">
                <div class="app-navbar__inner">
                    <b-navbar-brand :to="{ name: 'home' }" class="app-navbar__brand">
                        <div class="app-navbar__logo-shell">
                            <img :src="app_site_logo" alt="site logo">
                        </div>
                    </b-navbar-brand>

                    <ul class="navbar-nav app-navbar__actions flex-row flex-nowrap ml-auto">
                        <li class="nav-item app-navbar__item app-navbar__item--home">
                            <b-nav-item
                                :to="{ name: 'home' }"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-original-title="หน้าหลัก"
                                class="app-navbar__link app-navbar__link--icon"
                            >
                                <i class="icofont-home nav-icon"></i>
                            </b-nav-item>
                        </li>

                        <li class="nav-item app-navbar__item">
                            <b-nav-item
                                :to="{ name: 'lottery' }"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-original-title="แทงหวย"
                                class="app-navbar__link app-navbar__link--icon"
                            >
                                <i class="icofont-dice-multiple nav-icon"></i>
                            </b-nav-item>
                        </li>

                        <li class="nav-item app-navbar__item nav-credit">
                            <b-nav-item :to="{ name: '' }" class="app-navbar__credit-link">
                                <a
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    data-original-title="เครดิต"
                                    @click="loadUserBalance"
                                    class="app-navbar__balance-pill"
                                >
                                    <i class="fa fa-refresh hidden-xs app-navbar__refresh"></i>
                                    <span class="lotto-credit">{{ calculateUserBalance }} ฿</span>
                                </a>
                            </b-nav-item>
                        </li>

                        <li class="nav-item app-navbar__item">
                            <b-nav-item
                                :href="line_contact"
                                target="_blank"
                                class="app-navbar__link app-navbar__link--line"
                            >
                                <img :src="line_logo" class="app-navbar__line-logo" alt="line">
                            </b-nav-item>
                        </li>

                        <li class="nav-item app-navbar__item app-navbar__profile-item">
                            <div class="app-navbar__profile-shell">
                                <v-selectmenu
                                    :data="menu"
                                    :regular="true"
                                    :title="user.username"
                                    class="app-navbar__profile-menu"
                                    position="right"
                                    align="right"
                                >
                                    <span class="app-navbar__profile-trigger app-navbar__profile-trigger--icon-only">
                                        <i class="fa fa-user-circle app-navbar__profile-icon"></i>
                                        <span class="hidden-xs hidden-sm app-navbar__profile-name">{{ user.username }}</span>
                                    </span>
                                </v-selectmenu>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </b-navbar>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'navbar',
    data () {
        return {
            app_site_logo: '',
            line_logo: '',
            line_contact: '',
            userBalance: 0,
            menu: [
                { content:'<i class="fa fa-cogs"></i> บัญชีผู้ใช้งาน', callback: function(){ this.$router.push({name: 'account',}) } },
                { content:'<i class="fa fa-info-circle"></i> เปลี่ยนรหัสผ่าน', callback: function(){ this.$router.push({name: 'editpassword',}) } },
                { content:'<i class="fa fa-question"></i> ศูนย์ช่วยเหลือ', callback: function(){ this.$router.push({name: 'helpcenter',}) } },
                { content:'sm_divider' },
                { content:'<i class="fa fa fa-sign-out"></i> ออกจากระบบ', callback: function(){
                    if ( this.$Tawk ) {
                        this.$Tawk.$hideWidget()
                    }
                    this.$store.dispatch('user/userLogout')
                } },
            ],
        }
    },
    mounted() {
        this.$root.$on('navbar', () => {
            this.loadUserBalance()
        })
    },
    methods: {
        async logout () {
            var r = confirm('คุณต้องการออกจากระบบใช่หรือไม่?')
            if (r == true) {
                await this.$store.dispatch('user/userLogout')
                await this.$store.dispatch('ledger/userLogout')
                await this.$store.dispatch('orderhead/userLogout')
                location.reload()
                document.location.href = '/'
            }
        },
        async loadUserBalance () {
            if ( !this.user) {
                return
            }

            try {
                const response = await this.$store.dispatch('ledger/getUserBalance', this.user.account_id)
                if ( response.balance ) {
                    this.userBalance = this.formatMoney(response.balance.toFixed(2))
                }
                else {
                    this.userBalance = 0.00
                }
                return this.userBalance
            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                this.$toasted.error(error_msg)
                this.$store.dispatch('user/userLogout')
            }
        },
        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },
        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
            } catch (error) {
                console.log('error', error)
            }
        },
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        calculateUserBalance: function() {
            this.loadUserBalance()
            return this.userBalance
        },
        hideMenu: function() {
            if ( !this.user ) {
                return false
            }
            else {
                let page_name = this.$route.name
                if ( page_name.match(/register|forgot|login/g) ) {
                    return false
                }
            }
            return true
        },
    },
    created () {
        let logo = (process.env.VUE_APP_SITE).toLowerCase() + '_logo.png'
        try {
            this.app_site_logo = require('@/assets/images/'+ logo)
        } catch (error) {
            this.app_site_logo = require('@/assets/images/'+ 'dummy_logo.png')
        }
        this.line_logo = require('@/assets/images/'+ 'LINE_APP.png')
        this.loadLineContact()
    },
}
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
@import '~@/assets/css/app.scss';

.navbar-fixed-top {
    position: fixed !important;
    top: 0;
}

.navbar {
    margin-bottom: 0;
}

.navbar-section {
    background: transparent;
}

.app-navbar {
    // background: linear-gradient(135deg, #2E7D32 0%, #0f5413 100%) !important;
    background: linear-gradient(135deg, #0E2637 0%, #1A3346 100%) !important;
    box-shadow: 0 12px 28px rgba(9, 67, 15, 0.18);
    padding: 8px 0;
}

.nav-container {
    margin-left: auto;
    margin-right: auto;
}

.app-navbar__inner {
    min-height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}

.app-navbar__brand {
    padding: 0 !important;
    margin-right: 10px;
    flex: 0 0 auto;
}

.app-navbar__logo-shell {
    display: flex;
    align-items: center;
    justify-content: center;

    min-height: 54px;

    padding: 0 4px;

    border-radius: 14px;

    background: transparent;
    box-shadow: none;
}

.app-navbar__logo-shell img {
    height: 58px;
    width: auto;
    object-fit: contain;
    display: block;

    padding: 1.5px;
    background: linear-gradient(180deg, #c7982e 0%, #8f6515 100%);
    border: 1px solid #d6b15a;
    border-radius: 12px;

    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.12),
      inset 0 1px 0 rgba(255,255,255,.08);

    filter: drop-shadow(0 3px 6px rgba(0,0,0,.12));
}

.app-navbar__actions {
    align-items: center;
    gap: 8px;
    margin-left: auto;
}

.app-navbar__item {
    margin-left: 0 !important;
    padding-top: 0 !important;
    display: flex;
    align-items: center;
}

.app-navbar__link {
    padding: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.app-navbar__link--icon ::v-deep .nav-link,
.app-navbar__link--line ::v-deep .nav-link,
.app-navbar__credit-link ::v-deep .nav-link {
    padding: 0 !important;
}

.app-navbar__link--icon,
.app-navbar__link--line {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.10);
    transition: all 0.18s ease;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.app-navbar__link--icon:hover,
.app-navbar__link--line:hover {
    background: rgba(255, 255, 255, 0.18);
    transform: translateY(-1px);
}

.nav-icon {
    font-size: 20px;
    // color: #F9FDF9;
    color: #D0B06B;
    line-height: 1;
}

.app-navbar__credit-link {
    padding: 0 !important;
}

.app-navbar__balance-pill {
    min-height: 42px;
    padding: 0 14px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-decoration: none !important;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.10);
    transition: all 0.18s ease;
}

.app-navbar__balance-pill:hover {
    transform: translateY(-1px);
    background: #ffffff;
}

.app-navbar__refresh {
    // color: #2e7d32;
    color: #0E2637;
    font-size: 13px;
}

.lotto-credit {
    color: #263326;
    background-color: transparent;
    border-radius: 0;
    font-weight: 800;
    line-height: 1;
    padding: 0 !important;
    margin: 0;
    white-space: nowrap;
}

.app-navbar__line-logo {
    height: 22px;
    width: 22px;
    object-fit: contain;
    display: block;
}

.app-navbar__link--line {
    background: #1ecb39;
    box-shadow: 0 8px 16px rgba(30, 203, 57, 0.22);
}

.app-navbar__link--line:hover {
    background: #27d943;
}

.app-navbar__profile-item {
    margin-right: 0 !important;
    padding-right: 0 !important;
    flex: 0 0 auto;
}

.app-navbar__profile-shell {
    min-height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    flex: 0 0 auto;
}

.app-navbar__profile-trigger {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 0;
    background: rgba(255, 255, 255, 0.10);
    color: #fff;
    cursor: pointer;
    transition: all 0.18s ease;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
    overflow: hidden;
    flex: 0 0 42px;
}

.app-navbar__profile-trigger:hover {
    background: rgba(255, 255, 255, 0.18);
    transform: translateY(-1px);
}

.app-navbar__profile-icon {
    font-size: 22px;
    line-height: 1;
    color: #fff;
}

.app-navbar__profile-name {
    display: none !important;
}

@media (max-width: 575px) {
    .app-navbar__profile-shell {
        min-height: 34px;
    }

    .app-navbar__profile-trigger {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        flex: 0 0 34px;
    }

    .app-navbar__profile-icon {
        font-size: 18px;
    }

    .app-navbar__actions {
        gap: 5px;
    }
}

@media (max-width: 575px) {
    .app-navbar__actions {
        padding-right: 18px;
    }

    .app-navbar__item {
        flex: 0 0 auto;
    }
}

.fa-sticky-note {
    color: yellow;
}

.nav-link {
    @media (min-width: 992px) {
        padding-left: 0 !important;
    }
}

.navbar-brand {
    padding: 0 !important;
}

@media (max-width: 960px) {
    .lotto-credit {
        font-size: 13px;
    }
}

@media (min-width: 961px) {
    .lotto-credit {
        font-size: 15px;
    }
}

@media (max-width: 768px) {
    .app-navbar {
        padding: 7px 0;
    }

    .app-navbar__inner {
        min-height: 58px;
        gap: 10px;
    }

.app-navbar__logo-shell {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 100%;

    padding: 0 4px;

    position: relative;
    top: -2px;
}

    .app-navbar__logo-shell img {
        height: 58px;
        border-radius: 10px;
    }

    .app-navbar__actions {
        gap: 7px;
    }

    .app-navbar__link--icon,
    .app-navbar__link--line {
        width: 38px;
        height: 38px;
        border-radius: 12px;
    }

    .nav-icon {
        font-size: 18px;
    }

    .app-navbar__balance-pill {
        min-height: 38px;
        padding: 0 12px;
        gap: 6px;
    }

    .lotto-credit {
        font-size: 13px;
    }

    .app-navbar__line-logo {
        width: 20px;
        height: 20px;
    }

    .app-navbar__profile-shell {
        padding-right: 0;
    }

    .app-navbar__profile-icon {
        font-size: 30px;
    }
}

@media (max-width: 575px) {
    .app-navbar__inner {
        gap: 8px;
    }

    .app-navbar__brand {
        margin-right: 6px;
    }

.app-navbar__logo-shell {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 100%;

    padding: 0 4px;

    position: relative;
    top: -2px;
}
    .app-navbar__logo-shell img {
        height: 58px;
        border-radius: 10px;
    }
    .app-navbar__link--icon,
    .app-navbar__link--line {
        width: 34px;
        height: 34px;
        border-radius: 11px;
    }

    .nav-icon {
        font-size: 17px;
    }

    .app-navbar__balance-pill {
        min-height: 34px;
        padding: 0 9px;
        gap: 5px;
    }

    .lotto-credit {
        font-size: 12px;
    }

    .app-navbar__refresh {
        font-size: 11px;
    }

    .app-navbar__profile-icon {
        font-size: 24px;
    }
}

@media (max-width: 374px) {
    .app-navbar__inner {
        gap: 6px;
    }

    .app-navbar__logo-shell {
        padding: 0;
        border-radius: 10px;
    }

    .app-navbar__logo-shell img {
        height: 32px;
        padding: 1px;
        border-radius: 8px;
    }

    .app-navbar__link--icon,
    .app-navbar__link--line {
        width: 32px;
        height: 32px;
        border-radius: 10px;
    }

    .nav-icon {
        font-size: 15px;
    }

    .app-navbar__balance-pill {
        min-height: 32px;
        padding: 0 8px;
    }

    .lotto-credit {
        font-size: 11px;
    }

    .app-navbar__profile-icon {
        font-size: 25px;
    }

    @media (max-width: 575px) {
    .app-navbar__item--home {
        display: none !important;
    }
}
}
</style>